import api from "@/lib/api";

export const obCategories = () => api.get("/onboarding/categories").then((r) => r.data.docs);
export const obMine = () => api.get("/onboarding/mine").then((r) => r.data.docs);
export const obGet = (id) => api.get(`/onboarding/doc/${id}`).then((r) => r.data);
export const obSave = (payload) => api.post("/onboarding/save", payload).then((r) => r.data);
export const obUpload = (payload) => api.post("/onboarding/upload", payload).then((r) => r.data);
export const obUploadFile = (formData) => api.post("/onboarding/upload-file", formData).then((r) => r.data);
export const obQueue = (status) => api.get("/onboarding/queue", { params: status ? { status } : {} }).then((r) => r.data.docs);
export const obDecide = (payload) => api.post("/onboarding/decide", payload).then((r) => r.data);

export const aiAbout = (b) => api.post("/onboarding/ai/about", b).then((r) => r.data.text);
export const aiPortfolio = (b) => api.post("/onboarding/ai/portfolio", b).then((r) => r.data.text);
export const aiPricing = (b) => api.post("/onboarding/ai/pricing", b).then((r) => r.data.items);
export const aiSubcats = (b) => api.post("/onboarding/ai/subcategories", b).then((r) => r.data.suggestions);
